import { render, staticRenderFns } from "./COrgSelect.vue?vue&type=template&id=27c13634&"
import script from "./COrgSelect.vue?vue&type=script&lang=js&"
export * from "./COrgSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports